<template>
  <span
    class="boost-ended-icon"
    aria-hidden="true"
    :style="{ '--size': size + 'px' }"
  >
    <span class="art">
      <span class="wave"></span>
      <span class="wave second"></span>
      <BaseIcon
        icon-file="icons/tabbar/boost-ended"
        :width="size"
        :height="size"
      />
    </span>
  </span>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
// Consumables A/B: the Boost button's icon for 24 hours after the boost
// ended (Claude Design "Pulserande boost-ikon", variant 6) — a solid ring
// around the rocket with two ring waves pulsing out of it. Decorative; the
// button carries the label.
//
// The root is only the layout footprint: a plain 38 px block, like the
// BaseIcon it stands in for — the tab bar squeezes that block to fit its
// label, and an icon that refuses pushes the label down. The drawing is
// centred over the footprint and sized on its own (`size`), so a bar can
// enlarge the icon without moving anything around it.
export default {
  name: 'BoostEndedIcon',
  components: {
    BaseIcon
  },

  props: {
    // Side of the drawing in px. 38 is the design: the ring is drawn
    // smaller than the regular icon so the waves end inside the box.
    size: {
      type: Number,
      default: 38
    }
  }
};
</script>

<style lang="scss" scoped>
.boost-ended-icon {
  position: relative;
  display: block;
  width: 38px;
  height: 38px;
}

.art {
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--size);
  height: var(--size);
  margin: calc(var(--size) / -2) 0 0 calc(var(--size) / -2);
  pointer-events: none;
}

// The design's wave is an SVG circle (r 17.4, stroke 1.5) in a 54-unit
// viewBox: 36.3 / 54 of the drawing across, with a 1.5 / 54 line.
.wave {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: calc(var(--size) * 0.672);
  height: calc(var(--size) * 0.672);
  margin: auto;
  border: calc(var(--size) * 0.028) solid #9f41e9;
  border-radius: 50%;
  opacity: 0;
  animation: boost-wave 2.24s ease-out infinite;
}

.second {
  animation-delay: 1.12s;
}

@keyframes boost-wave {
  0% {
    transform: scale(1);
    opacity: 0.45;
  }

  100% {
    transform: scale(1.45);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .wave {
    animation: none;
  }
}
</style>
